import React, { useState, useRef } from 'react'
import Modal from 'react-bootstrap-modal'
import BraintreePaymentModal from '../braintree-payment-modal'
import SelectPaymentModal from '../select-payment-modal'
import FlashAlert from '../flash-alert'
import { ajaxPost } from '../../ajax'

export default function CancelGame({game, onClose, onCancel}) {
  const [reason, setReason] = useState('')
  const [charge, setCharge] = useState(0.0)
  const [percent, setPercent] = useState(0)
  const chargeRef = useRef(null)
  
  const [showPayment, setShowPayment] = useState(false)
  const [manualPayment, setManualPayment] = useState(false)
  const [alert, setAlert] = useState(null)

  const playersReason = 'Not enough players'
  const placeReason = 'Out of town'
  const weatherReason = 'Weather'

  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const reasonClass = (reasonText) => {
    return reason == reasonText ? 'selected' : ''
  }

  const otherReasonClass = () => {
    return (reason != playersReason && reason != placeReason && reason != weatherReason) ? 'selected' : ''
  }

  const chooseReason = (text) => {
    setReason(text)
  }

  const setAmountFromPercent = (chargePercent) => {
    const chargeAmount = (game.cost/100) * chargePercent
    setCharge(parseFloat(chargeAmount).toFixed(2))
  }

  const setPercentFromAmount = (chargeAmount) => {
    const chargePercent = (chargeAmount/game.cost) * 100
    setPercent(parseInt(chargePercent))
  }

  const choosePercent = (chargePercent) => {
    setPercent(chargePercent)
    setAmountFromPercent(chargePercent)
  }

  const chooseAmount = (e) => {
    const value = Number(e.target.value)
    e.target.value = value
    setCharge(value)
    setPercentFromAmount(value)
  }

  const chooseOtherPercent = () => {
    setCharge(0)
    setPercent(0)
    chargeRef.current.value = 0
    chargeRef.current.focus()
    chargeRef.current.select()
  }

  const percentClass = (chargePercent) => {
    return percent == chargePercent ? 'selected' : ''
  }

  const otherPercentClass = () => {
    return (percent != 25 && percent != 50 && percent != 75) ? 'selected' : ''
  }

  const startCancellation = () => {
    if (charge) {
      App.store.dispatch({type: "FLASH_CLEAR"})
      setShowPayment(true)
    } else {
      onSubmit()
    }
  }

  const closePayment = () => {
    setShowPayment(false)
    setManualPayment(false)
  }

  const onPaymentType = (type) => {
    if (type === 'CASH') {
      onSubmit('cash')
    } else if (type === 'MANUAL_CARD') {
      setShowPayment(false)
      setManualPayment(true)
    }
  }

  const onSubmit = (type = 'none', token) => {
    closePayment()
    const data = {
      payment: {type, token},
      cancellation: {chargeAmount: charge, text: reason}
    }
    ajaxPost(`/admins/reservations/${game.id}/cancellations`, data)
      .then(response => {
        if (response.ok) {
          onCancel()
        } else {
          return response.json()
        }
      })
      .then(json => { if (json) setAlert(json.alert) })
  }

  return <Modal container={document.body} show={true} onHide={onClose} dialogClassName='game-cancellation-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Cancel Game</Modal.Title>
    </Modal.Header>
    <div className='game-cancellation'>
      { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
      <div>
        <div className='game-cancellation__reason'>
          <h2>Reason</h2>
          <button className={reasonClass(playersReason)} onClick={(e) => chooseReason(e.target.innerHTML)}>{playersReason}</button>
          <button className={reasonClass(placeReason)} onClick={(e) => chooseReason(e.target.innerHTML)}>{placeReason}</button>
          <button className={reasonClass(weatherReason)} onClick={(e) => chooseReason(e.target.innerHTML)}>{weatherReason}</button>
          <button className={otherReasonClass()} onClick={(e) => chooseReason('')}>Other...</button>
        </div>
        <div className='game-cancellation__amount-presets'>
          <h2>Cancellation Charge</h2>
          <h3>{`Reservation Total${currencyName}: $${game.cost}`}</h3>
          <div className='game-cancellation__preset-buttons'>
            <button className={percentClass(25)} onClick={() => choosePercent(25)}>25%</button>
            <button className={percentClass(50)} onClick={() => choosePercent(50)}>50%</button>
            <button className={percentClass(75)} onClick={() => choosePercent(75)}>75%</button>
            <button className={otherPercentClass()} onClick={() => chooseOtherPercent()}>Custom</button>
          </div>
        </div>
      </div>
      <div>
        <textarea placeholder='Other...' value={reason} onChange={(e) => chooseReason(e.target.value)} />
        <div className='game-cancellation__amount'>
          <h3>{`Charge Total${currencyName}`}</h3>
          <div className='game-cancellation__amount-input'>
            $<input 
              type='number' 
              min='0' 
              step='0.01'
              ref={chargeRef}
              value={charge}
              style={{width: 25 + 25 * (charge || 0).toString().length}}
              onChange={(e) => chooseAmount(e)}
            />
          </div>
        </div>
      </div>
      <div className='game-cancellation__footer'>
        <button onClick={startCancellation}>Cancel Reservation</button>
      </div>
      <SelectPaymentModal isOpen={showPayment}
        onRequestClose={closePayment}
        onPaymentTypeSelected={onPaymentType}
        style={{}} 
      />
      <BraintreePaymentModal isOpen={manualPayment}
        amount={Number(charge)}
        onRequestClose={closePayment}
        onPaymentMethodReceived={(method) => onSubmit('card_number', method.token) } 
      />
    </div>
  </Modal>
}
